<template>
  <UploadOption />
</template>

<script>
import UploadOption from '@/components/user/UploadOption.vue';

  export default {
    components: {
      UploadOption,
    }
    
  }
</script>

<style lang="scss" scoped>

</style>